module.exports = __webpack_public_path__ + "img/marisa kirisame scarlet.cca53786.png";